import React, { useEffect, useState } from "react";
import { isMobile, isMobileOnly } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import axios from "axios";
import { base_url, postHeader } from "../../../../../Helpers/request";
import { toast } from "react-toastify";
import Slider from "react-slick";
import leftArrow from "../../../../../Assets/adore-imgs/left-arrow.png";
import RightArrow from "../../../../../Assets/adore-imgs/right-arrow.png";
import slider from "react-slick";
const BannerSlider = () => {
  const history = useHistory();
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //-----------------------------------Banner
    setLoading(true);
    axios
      .get(base_url + `/home/slider`, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setLoading(false);
          setBanner(response.data.data);
          localStorage.setItem(
            "bw-bannerdata",
            JSON.stringify(response.data.data)
          );
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    autoplay:true,
     pauseOnHover: false,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <img src={leftArrow} alt="prev" className="custom-arrow" />,
    nextArrow: <img src={RightArrow} alt="next" className="custom-arrow" />,
  };
  return (
    // <>
    //   {!loading ? (
    //     banner?.map((val, index) => (
    //       <div
    //         className="rcs_hero_slider"
    //         style={{
    //           backgroundImage: `url(${
    //             isMobileOnly ? val?.mobile_image : val?.image
    //           })`,
    //         }}
    //       >
    //         <div className="rcs_hero_img">
    //           <Container fluid>
    //             <Row className={`m-auto w-100 ${isMobile ? "justify-content-center" : ""}`}>
    //               <Col md={6} className="p-0">
    //                 {val.btn_text === "" ? (
    //                   ""
    //                 ) : (
    //                   <div
    //                     className={`${
    //                       isMobile ? "text-center" : val.text_direction_class
    //                     } text-center`}
    //                   >
    //                     <h1 data-aos="fade-up-left" data-aos-duration="700">
    //                       {val.title}
    //                     </h1>
    //                     <p
    //                       data-aos="fade-up-left"
    //                       data-aos-duration="1200"
    //                       data-aos-delay="300"
    //                     >
    //                       {val.short_text}
    //                     </p>
    //                     <Button
    //                       data-aos="fade-up-left"
    //                       data-aos-duration="1800"
    //                       data-aos-delay="400"
    //                       onClick={() => {
    //                         history.push("/" + val.btn_link);
    //                       }}
    //                       className="outline-base-btn large"
    //                     >
    //                       {val.btn_text}
    //                     </Button>
    //                   </div>
    //                 )}
    //               </Col>
    //             </Row>
    //           </Container>
    //         </div>
    //       </div>
    //     ))
    //   ) : (
    //     <div className="sk" style={{ margin: "0px" }}>
    //       <Skeleton variant="text" animation="wave" height={"90vh"} />
    //     </div>
    //   )}
    // </>
    <>
      {!loading ? (
        <Container fluid>
          <Row>
            <Col sm={12} md={12} lg={12} className="p-0">
              <div className="tl_banner_slider">
                <Slider {...settings}>
                  {banner.map((val, index) => (
                    <div className="tl_slider_itemm_box">

                      <div key={index} className="slider-item position-relative">
                        <Image
                          src={isMobileOnly ? val?.mobile_image : val?.image}
                          alt={val?.title || "banner"}
                          fluid
                        //  onClick={() => history.push("/" + val?.btn_link)}
                        />
                        {val?.btn_text && (
                          // <div
                          //   className={`${
                          //     isMobile ? "text-center" : val.text_direction_class
                          //   } text-overlay text-box banner_text_box`}
                          // >

                          <div
                            className={`${isMobile ? "text-center" : val.text_direction_class} text-overlay text-box banner_text_box ${index === 1 || index === 2 ? "second-slide-class_left" :  "second-slide-class_right"
                              } ${index !== 0 && index !== 2  ? "text_white_first_slide" : ""
                              }`}
                          >
                            <h1>{val.title}</h1>
                            <p>{val.short_text}</p>
                            <button
                              onClick={() => history.push("/" + val?.btn_link)}
                              className="btn_bannerr"
                            >
                              {val.btn_text}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </Col>
          </Row >
        </Container >
      ) : (
        <div className="sk" style={{ margin: "0px" }}>
          <Skeleton variant="text" animation="wave" height={"90vh"} />
        </div>
      )}
    </>
  );
};

export default BannerSlider;
